export default __webpack_public_path__ + "static/media/Clock_Blue.bb0eb431.webp";